export default __webpack_public_path__ + "static/media/ic-female.a2e60d46.svg";